module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('insurance-table', {
    attrs: {
      "site-id": _vm.rowData.id,
      "cient-site-id": _vm.rowData.siteId,
      "read-only": _vm.readOnly,
      "site-name": _vm.rowData.siteName
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13261757"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteInsurance.vue
// module id = 1431
// module chunks = 0